// extracted by mini-css-extract-plugin
export default {"lineBreak":"announcement-theme--lineBreak--TNk2YuWv"};